/* eslint-disable */
import store from '../store'

const authGuard = (to, from, next) => {
  if(!store.getters.isFirstLoading) {
    if(store.getters.isAuthenticated)
      next()
    else
      if(to.path !== '/login') next('/login')
  } else next()
};

export default authGuard;


// WEBPACK FOOTER //
// ./src/auth/guard.js